// 초기화
const initialState = {
  show: false,
  title: "",
  Content: "",
  callback: null,
  Buttons: undefined,
};

// 리듀서 작성
// function global_loading(state = initialStete, action) {
export const modal_state = (state = initialState, action) => {
  switch (action.type) {
    case "modal/GLOBAL_STATE/ON": {
      return { ...state, stores: action.payload };
    }
    case "modal/GLOBAL_STATE/OFF":
      return { stores: initialState };
    default:
      return state;
  }
};
